export const ATHLETE_HEADSHOT_SILHOUETTE_IMAGE = `data:image/svg+xml;utf8,${encodeURIComponent(`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 317 232" width="317" height="232" aria-hidden="true" role="img">
    <defs>
      <linearGradient id="athlete-skeleton-silhouette" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stop-color="#343434"/>
        <stop offset="48%" stop-color="#171717"/>
        <stop offset="100%" stop-color="#050505"/>
      </linearGradient>
    </defs>
    <path fill="url(#athlete-skeleton-silhouette)" d="M 22 226 L 22 231 L 299 231 L 293 213 L 291 212 L 286 201 L 277 190 L 263 182 L 257 181 L 256 179 L 252 178 L 248 174 L 243 173 L 242 171 L 236 170 L 235 168 L 217 162 L 210 155 L 203 154 L 202 152 L 197 151 L 194 148 L 194 123 L 196 121 L 196 116 L 201 115 L 205 110 L 205 105 L 207 102 L 207 94 L 209 91 L 209 83 L 207 79 L 204 78 L 205 49 L 201 41 L 196 36 L 196 33 L 189 25 L 174 17 L 160 14 L 149 15 L 134 20 L 130 24 L 130 26 L 125 30 L 120 38 L 120 43 L 117 47 L 117 51 L 115 54 L 115 74 L 117 75 L 117 77 L 112 82 L 112 93 L 114 94 L 115 109 L 120 115 L 125 116 L 126 148 L 123 151 L 117 152 L 116 154 L 109 155 L 108 157 L 106 157 L 106 159 L 103 162 L 97 163 L 95 165 L 85 168 L 84 170 L 78 171 L 67 178 L 63 179 L 62 181 L 52 184 L 46 189 L 44 189 L 31 205 L 30 210 L 28 211 Z"/>
  </svg>
`)}`;

const LEGACY_ATHLETE_SILHOUETTE_MARKER = "athlete-skeleton-silhouette";

export const isFallbackHeadshotImage = (src) => {
  const value = typeof src === "string" ? src.trim() : "";

  return (
    !value ||
    value === ATHLETE_HEADSHOT_SILHOUETTE_IMAGE ||
    (value.startsWith("data:image/svg+xml") && value.includes(LEGACY_ATHLETE_SILHOUETTE_MARKER))
  );
};
